var cart_ref = 0;
function get_price(){
  var mf = "";
  var total = 0;
  $('.stlpopup-wrap').each(function(){
    total = total + parseInt($(this).find('input[name="variant_id"]').attr('data-price'));
  });
  $('.price_in_popup').html(Shopify.formatMoney(total, mf));
//   if($('.stlpopup-wrap.active [data-vmoney]').length){
//     var klarna_m = parseInt($('.stlpopup-wrap.active [data-vmoney]').attr('data-vmoney')) / 4;
//     $('.klarna_popup_price').html(Shopify.formatMoney(klarna_m, mf))
//   }
}

if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
  // Get from cart.js returns the cart in JSON
  if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
      }
      else {
        Shopify.onCartUpdate(cart);
          }
      });
    }else{
      if ((typeof callback) === 'function') {
      callback(cart);
    }else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}
$(document).ready(function(e) {

  function closePopup() {
    $('.popupBox').removeClass('fadeInUp');
    $('.popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
    $('.cls_popup').remove();
    $('body').removeClass('popupOpned');
    
    if($('#manvideo').length) {
      $('#manvideo')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');   
    }
  }
  function openPopup(a) {
    $('.popupBox').addClass('fadeInUp');
    $('.popupBox').removeClass('slideOutUp');
    $('.popupOverlay.'+a).fadeIn('slow');
    $('body').addClass('popupOpned');
    $('.popupBox').append('<a class="cls_popup" ></a>');
  }

  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }  
  }
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });

  // $('.topbar a').on('click', function(e){
  //   e.preventDefault();
  //   openPopup('topbarShipping');
  // });


  $('.pdpShippingMsg a').on('click', function(e){
    e.preventDefault();
    openPopup('addnlContent');
  });
  
  $('.afterpayLink').on('click', function(e){
    e.preventDefault();
    openPopup('afterpayPopup');
  });
  
  

  function refreshHeigh() {
    var bh = $('.cartButtonOuter').height()+65;
    var vh = window.innerHeight;
    var newh = vh-bh;
    var qih = $('.quick-items').height();
    $('.cartDrawer').removeClass('nofix');
    $('.quick-items').removeAttr('style');
    if(newh > 115) { // 115 is one line-item height in cart 
      if(qih > newh) {
        $('.quick-items').css('max-height',newh+'px').css('overflow-y','scroll');
      }
    }
    else {
      $('.cartDrawer').addClass('nofix');
    }
  }

  refreshHeigh();

  $(window).resize(function(){
    setTimeout(function() {
      refreshHeigh();
      $('.cartDrawer').css("height", window.innerHeight+'px');
    }, 50); 
  });

  $('.dropdownmenu').each(function(){
    var lp = $(this).offset().left;
    if(lp < 0) {
      $(this).parent().addClass('rmPosRel');
    }
  });
  $('.hasDropDown').hover(function(){
    var d = $(this).find('.dropdownmenu');
    if(d.length) {
      var lp = d.offset().left;
      if(lp < 0) {
        $(this).addClass('pushtoLeft');
      } else {
        $(this).removeClass('pushtoLeft');
      }
      var rp = ($(window).width() - (d.offset().left + d.outerWidth()));
      if(rp < 0) {
        $(this).addClass('pushtoRight');
      } else {
        $(this).removeClass('pushtoRight');
      }
    }
  });

  $('.mobileNav').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('menuOpen');
      $('.fullPage').addClass('witmenu');
    }, 100);
  });
  $('.filterToggle').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('filterOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });
  
  $('#mainNavMob').on('click','.toggleItem',function(e){
    if($(this).hasClass('opend')) {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
    } else {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
      $(this).addClass('opend');
      $(this).parent().next('ul').addClass('toggleSubMenu');
    }
  });
  $('#mainNavMob').on('click','.backTitle',function(e){
    $('.toggleItem').removeClass('opend');
    $('.dropdownmenu').addClass('hideToggleMenu');
    setTimeout(function(){
      $('.dropdownmenu').removeClass('toggleSubMenu').removeClass('hideToggleMenu');
    },500);
    
  });
  
  $('body').on('click','.fullPage.witmenu, .closemenu, .closecart', function(e){
    if($(this).closest('.colSidebar').length) {
      return false;
    }
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
  });
  
  $('.menu-overlay').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
  });
  
  
  
  $('.mobToggler').on('click',function(e){
    $(this).next('ul, div').slideToggle().next('.store_locator').slideToggle();
    $(this).toggleClass('opned');
  });
  
  $('body').on('click','.size_chart_link[data-product]',function(e){
    e.preventDefault();
    $('#sizes-modal-' + $(this).attr('data-product')).modal();
  });
  
  $('body').on('click','.yotpo.bottomLine.sbsr',function(e){
    e.preventDefault();
    if(jQuery(window).width() < 768) {
      if($(this).closest('.stlpopup-wrap').find('.mobile_only .yotpo-main-widget').length){
        $(this).closest('.stlpopup-wrap').find('.rightcol').animate({
          scrollTop: $(this).closest('.stlpopup-wrap').find('.mobile_only .yotpo-main-widget').offset().top - $('header').outerHeight()
        }, 500);
      }
    }else{
      if($(this).closest('.stlpopup-wrap').find('.desktop_only .yotpo-main-widget').length){
        $('html, body').animate({
          scrollTop: $(this).closest('.stlpopup-wrap').find('.desktop_only .yotpo-main-widget').offset().top - $(this).closest('.stlpopup-wrap').find('.stlpopup-footer').outerHeight()
        }, 500);
      }
    }
  });
  
  window.onload = function() {
    $('.full_banner').each(function(){
      var img = $(this).attr('data-banner');
      $(this).css('background-image','url('+img+')');
      $(this).find('img').attr('src',img);
    });
    if($(window).width() <= 991) {
      $('.afterLoad').each(function(){
        var img = $(this).attr('data-src');
        $(this).attr('src', img);
      });
    }
  };

  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('#crt').html(data);
      $('#crt').removeClass('loading');
      
      setTimeout(function() {
        refreshHeigh();
        $('.cartDrawer').css("height", window.innerHeight+'px');
      }, 100); 
      //Currency.convertAll(shopCurrency, $('.currentCurreny > span').text());
      //jQuery('.currentCurreny > span').text(Currency.currentCurrency); 
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    });
  }

  $('.cartOuter').on('mouseenter, click',function(e){
    if($(this).find('.cartCount').text()!="0") {
      //addToCartSuccess();
      e.preventDefault();
      setTimeout(function(){
        $('body').addClass('cartOpen');
        $('.fullPage').addClass('witmenu');
      }, 50);
    }
  });
  

   
  $('.cartCount').on("DOMSubtreeModified",function(){
    addToCartSuccess();
  });
  
  

  $('body').on('click','.addtocart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.val('Adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        if(jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        }
        btn.val('Add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      //addToCartSuccess();
      btn.val('Add to cart');
      btn.removeAttr('disabled');
      Shopify.getCart( function(c){
        $('.cartCount').text(c.item_count);
      });
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    });

  });
  $('body').on('click','.giftaddtocart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    var varient_id = $('.swatch-variant .gift-product-list input:checked').attr('data-variant'); 
    btn.attr('disabled', 'disabled');
    btn.val('Adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: varient_id
      },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        if(jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        }
        btn.val('Add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      //addToCartSuccess();
      btn.val('Add to cart');
      btn.removeAttr('disabled');
      Shopify.getCart( function(c){
        $('.cartCount').text(c.item_count);
      });
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    });
  });

  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount, .cartCount').text(c.item_count);
      if(!c.item_count) {
        $('.itemCount').text('0');
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
      }/* else {
        addToCartSuccess();
      }*/
    });
  });

  $('body').on('click', '.quick-cart-details .adjust',function(){

    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);


    $('#crt').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crt').removeClass('loading');
      },
      success: function(){
        //addToCartSuccess();
        Shopify.getCart( function(c){
          $('.itemCount, .cartCount').text(c.item_count);
        });
        $('#crt').removeClass('loading');
      }
    });

  });

  $('.item-quantityg').keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });

  $('.tablist ul li').click(function(e){
    e.preventDefault();
    $('.tablist ul li').removeClass('activetab');
    $('.relatedProductC').hide();
    var currenTab = $(this).data('id');
    $(this).addClass('activetab');
    $('#'+currenTab).show();
    //var x = $(this).attr('data-slick');
    if($('.responsive').hasClass('slick-initialized')) {
      $('.responsive').slick('refresh');
    }
  });


  $('.responsive').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  if($('#myVideo').length) {
    document.getElementById("myVideo").pause();
  }
  $(".fancybox_viral").click(function(event){
    event.preventDefault();
    document.getElementById("myVideo").play();
    $('.viralsweep_popup').addClass('open_viralpopup');
    $('body').addClass('open_viralpopupbody');
    $('html').addClass('open_viralpopuphtml');
  });
  $(".inner_viral_close").click(function(event){		
    event.preventDefault();
    document.getElementById("myVideo").pause();
    $('.viralsweep_popup').removeClass('open_viralpopup');
    $('body').removeClass('open_viralpopupbody');
    $('html').removeClass('open_viralpopuphtml');
  });
   
  var baseURL = "https://services.superga-usa.com/";
  $('.mainNewsletter').on('submit',function(e){
    // This prevents the form from submitting
    e.preventDefault();    
    var x = true;
    $('.err-msg').remove();
//     debugger;
    var form = $(this);
    var email = form.find("input[type='email']").val().trim();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
    } else {
      em.parent().find('.err-msg').remove();
    }

    if(x){
//        debugger;
          //  url: 'https://ea143a3d.ngrok.io/Responsys/AddNewsLetter',
      $.ajax({
        type: "POST",
        url: baseURL + 'Responsys/AddNewsLetter',
        data: "email="+email+"&page=PopUp",
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          console.log(json);
          form.hide();
          form.parent().append("<span class='successMsg'>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");
          $('.nlMore input[type="email"]').val(email);
          //openPopup('nlMsg');
        },
        error: function (e) {
          //debugger;
          form.append('<p class="err-msg">Please try after some time!</p>');
        }
      });
    }
  });
  
  
function addtocart_button_reboot_normal(){
  jQuery.get( "/cart?view=check_used", function( data ) {
    var final_data = JSON.parse(data);
    if(final_data.has_used && !$('body.used_pdp').length){
      $('body').addClass('used_condition_occur');
    }else if(final_data.has_normal && $('body.used_pdp').length){
      $('body').addClass('used_condition_occur');
    }else{
      $('body').removeClass('used_condition_occur');
    }
  });
}
addtocart_button_reboot_normal();
  
  $('body').on('click','.close-icon, .count-shopping, .continue_shop_reboot', function(e){
    jQuery('.rebooted_popup').removeClass('active');
    jQuery('.stlPopupCont').html('<img class="stlLoading" src="https://cdn.shopify.com/s/files/1/2170/8465/files/Reload.svg?v=1614273530" alt="" />');
    jQuery('body').removeClass('popupOpned');
    jQuery('#stl-cont').hide();
    if(parseInt(jQuery('#stl-cont').attr('data-addcnt')) > 0){
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');  
      jQuery('#stl-cont').attr('data-addcnt',0);
      $.getJSON('/cart.js', function(c){
        $('.cartCount').text(c.item_count);
        addtocart_button_reboot_normal();
      });
    }
    $('body').removeClass('full_height');
    $('.stl-popup').removeClass('full_height');     
    if($('.topbar-rolling-text.slick-initialized').length){
      $('.topbar-rolling-text.slick-initialized').slick('refresh');
    }
  });
  $('body').on('click','.close-error, .close_nd_animate', function(){
    $('.error-popup').hide();
    $('body').removeClass('select_size_popup');
    $('.stlpopup-wrap.active').find('.cart-button').prop('disabled', false);
    $('.stlpopup-wrap.active .sizcart-col.product-opt, body.product .productInfo .select_size, body.product .cm_add_bag_btns .selector-wrapper.is-size, body.product .cm_add_bag_btns .drop').addClass('pulse');
    setTimeout(function(){
      $('.stlpopup-wrap .sizcart-col.product-opt, body.product .productInfo .select_size, body.product .cm_add_bag_btns .selector-wrapper.is-size, body.product .cm_add_bag_btns .drop').removeClass('pulse');
    },1000);
  });
  $('body').on('click','.trigger-product', function(e){
    e.preventDefault();
    var handle = $(this).attr('data-product');
    var indx = $(this).attr('data-indx');
    var title = $(this).attr('data-title');
    var pid = $(this).attr('data-pid');
    $('.stl-popup').find('.stlpopup-wrap').removeClass('active');
    $(this).closest('.stl-popup').find('.stlpopup-wrap[data-indx="'+indx+'"]').addClass('active');
    $('.trigger-product').removeClass('active');
    var s = $(this).attr('data-product');
    $('.trigger-product[data-product="'+s+'"]').addClass('active');
    if(jQuery(window).width() < 768) {
      if(typeof put_height === 'function'){
        put_height();
      }
    }
    if($('.stlpopup-wrap.active .relatedslider.slick-initialized').length){
      $('.stlpopup-wrap.active .relatedslider').slick('refresh');
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer = window.dataLayer || [];
    var newid = 'dataLayerData_'+pid;
    window.dataLayer.push(window[newid]);
    get_price();
  });
  jQuery('body').on('click','.stl_btn, .product_img_gird', function(e){
    e.preventDefault();
    jQuery('#stl-cont').show();
    jQuery('body').addClass('popupOpned');
    var btnImg = jQuery(this).attr('data-image');
    var handle = '/products/'+jQuery(this).attr('data-product')+'?view=shopthelook';
    jQuery.get(handle, function(data) {
      if(data) {
        jQuery('.stlPopupCont').html(data);
        jQuery('#ex_0').attr('data-img',btnImg);
        jQuery('#ex_0').attr('data-thumb',btnImg).html('<img src="'+btnImg+'" alt="" />');
         $('.relatedslider').slick('refresh');
      }
    });
  });
  $('body').on('click','.swatchClr', function(e){
    e.preventDefault();
    if($(this).hasClass('active'))
      return false;

    var a= $(this);
    var u = a.attr('href');
    var pid = a.attr('data-id');
    var pdiv = $(this).closest('.stlpopup-wrap');
    var stl = pdiv.find('.footer-leftcol').html();
    var handle = u+'?view=shopthelook1';
    if($('.product-v2_product').length){
      handle = u+'?view=V2_product1';
    }
    var ph = u.replace('/products/');
    jQuery.get(handle, function(data) {
      pdiv.html(data);
      pdiv.attr('data-product',ph).attr('id', 'p'+pid)
      pdiv.find('.footer-leftcol').html(stl);
      if($('body').attr('data-redirection_code') == 'true'){
        $('.swatchClr:not(.done)').each(function(){
          var a= $(this);
          var u = a.attr('href');
          $.get(u+'?view=shopthelookClr',function(p){
            if(p.indexOf('custom_anchore_pdp') > -1){
              if(p=='') {
                a.hide();
              } else {
                if(a.hasClass('active')) {
                  p.replace('replaceActive','active');
                } 
                a.html(p);
                if(a.hasClass('active')) {
                  var activeimg = $('.stlpopup-wrap.active .rightcolbody-content .swatchClr.active a').html();      
                  $('.stlpopup-footer .trigger-product[data-indx="'+ $('.stlpopup-wrap.active').attr('data-indx') +'"]').html(activeimg);
                  var p_title = $('.stlpopup-wrap.active .rightcolbody-content .swatchClr.active a').attr('data-p_title');
                  $('.stlpopup-wrap.active .only_p_t').html(p_title);
                }
              }
            }else{
              a.hide();
            }
          }).error(function() { 
            a.remove(); 
          });
          $(this).addClass('done');
        });
      }
//       jQuery('#sidebar .scrollbar-inner').scrollbar();
      if($(window).width() > 1024){
        $('.stlpopup-wrap .leftcol-wrap .img-wrap').each(function(i,v){
          $('#'+$(this).attr('id')).zoom();
        });
      }
      if(typeof Yotpo !== 'undefined'){
//         var api = new Yotpo.API(yotpo);
//         api.refreshWidgets();
      }
    });
  });

  $('body').on('click','.cart-button', function(e){
    e.preventDefault();
    var t = $(this);
    t.attr('disabled','disabled');
    var vid=[];
    //     $('body').find('.stlpopup-wrap.active').each(function(){
    //       var t1=$(this);
    //       var v = t1.find('input[name="variant_id"]').val();
    //       if(v != '' && v != null && v != undefined){
    //         vid.push(v);
    //       }
    //     });
    var v = $('body .stlpopup-wrap.active').find('input[name="variant_id"]').val();
    if(v != '' && v != null && v != undefined){
      vid.push(v);
    }
    if(vid.length == 0){
      $('.error-popup').show();
      $('body').addClass('select_size_popup');
      return false;
    }
    else{
      $('.error-popup').hide();
      $('body').removeClass('select_size_popup');
      let iterations = vid.length;
      var data = [];
      for (var i of vid.reverse()) {
        //if (!--iterations){
        var items = {};
        items.id = i;
        items.quantity = 1;
        var prop = {};
//         prop['Shop the look'] = window.mptl;
        if($('body .stlpopup-wrap.active #productbarcode').length){
          prop['UPC'] = $('body .stlpopup-wrap.active #productbarcode').val();
        }
        if($('body .stlpopup-wrap.active #preordermessage').length){
          prop['EXPECTED SHIP DATE'] = $('body .stlpopup-wrap.active #preordermessage').val();
        }
        if($('body .stlpopup-wrap.active .back_order_properties').length){
          prop['Back-ordered items'] = $('body .stlpopup-wrap.active .back_order_properties').val();
        }
        if($('body .stlpopup-wrap.active .pre_order_properties').length){
          prop['Pre-ordered items'] = $('body .stlpopup-wrap.active .pre_order_properties').val();
        }
        items.properties = prop;
        data.push(items);
      }
      $.post('/cart/add.js', {
        items: data
      }, function(pro){
        t.removeAttr('disabled');
        $('#stl-cont').attr('data-addcnt',(parseInt($('#stl-cont').attr('data-addcnt')) + 1));
        $('body .stlpopup-wrap').find('.cart-count').text($('#stl-cont').attr('data-addcnt'));
        window.dataLayer = window.dataLayer || [];
        var c = pro.items[0];
        window.dataLayer.push({
          event: 'stl_add_to_cart',
          addToCart: {
            product: {
              id: c.product_id,
              sku: c.variant_id,
              style: c.sku,
              name: c.title,
              price: (parseInt(c.final_price)/100).toFixed(2),
              basePrice: (parseInt(c.original_price)/100).toFixed(2),
              quantity: 1,
              brand: c.vendor,
              upc: $('body .stlpopup-wrap.active #productbarcode').val(),
              isPreOrder: Number($('body .stlpopup-wrap.active .isPreOrder').val()),
              isBackOrder: Number($('body .stlpopup-wrap.active .back_order_properties').val()),
              color: c.variant_options[0].trim(),
              colorFamily: c.variant_options[0].trim(),
              size:c.variant_options[1].trim(),
              expectedShipDate:$('body .stlpopup-wrap.active #preordermessage').val()
            }
          },
          data: c
        })
        if($('body.is_v2_product').length){
          $('body').addClass('cartOpen');
          $('.fullPage').addClass('witmenu');  
          $.getJSON('/cart.js', function(c){
            $('.cartCount').text(c.item_count);
            addtocart_button_reboot_normal();
          });
        }
      },'JSON').fail(function(response) {
        t.removeAttr('disabled');
        alert('Something went wrong...');
      })
    }
  });

  $('body').on('click','.yotpo.bottomLine.sbsr',function(){
    if(jQuery(window).width() < 768) {
      if($(this).closest('.stlpopup-wrap').find('.mobile_only .yotpo-main-widget').length){
        $(this).closest('.stlpopup-wrap').find('.rightcol').animate({
          scrollTop: $(this).closest('.stlpopup-wrap').find('.mobile_only .yotpo-main-widget').offset().top - $('header').outerHeight()
        }, 500);
      }
    }else{
      if($(this).closest('.stlpopup-wrap').find('.desktop_only .yotpo-main-widget').length){
        $('html, body').animate({
          scrollTop: $(this).closest('.stlpopup-wrap').find('.desktop_only .yotpo-main-widget').offset().top - $(this).closest('.stlpopup-wrap').find('.stlpopup-footer').outerHeight()
        }, 500);
      }
    }
  });
  
  function additems(v){
    $.ajax({
      url: '/cart/add.js',
      data: { id: v },
      type: 'POST',
      dataType: 'json',
      async:false,
      success: function(cart){
        console.log(cart);
      },
      error: function(){
        console.log('error')
      }
    });
  }

  $('body').on('click','.stl-popup .rightcol-body .description.tabbing h3',function(){
    $(this).next().slideToggle();
    $(this).toggleClass('tabOpen');
  });
  $('body').on('change','.stlpopup-wrap .single-option-selector.size',function(){
    if($(this).val() == ''){
      $(this).closest('.stlpopup-wrap').find('#preproperties').remove();
      $(this).closest('.stlpopup-wrap').find('.tooltiptext').hide();
      $(this).closest('.stlpopup-wrap').find('input[name="variant_id"]').val('');
    }
  });
  $('body').on('click','.stl-popup .footer-row .footer-leftcol .up_arrow_popup',function(){
    if(jQuery(window).width() < 768) {
      $('.stl-popup').addClass('full_height');     
      if($('.product-v2_product').length){
        $('body').addClass('full_height');     
      }
    }
  });

  $('body').on("click",".play_icon",function(){
    var video  = $(this).closest('.video_banner').find('video')[0];
    $(this).hide();
    video.play();
  });
  var video = $('.video_banner').find(".video");
  $.each(video,function(index, val){
    val.onended = function(e) {
      var video_btn  = $(this).closest('.video_banner').find('.play_icon');
      video_btn.show();
    };
  });

   $('body').on('keyup focus','.contact_us_wrapper .store_find',function(e){
    $('.ui-autocomplete').addClass("hide_autosearch");
    var search = $(this).val();
    $('.nsw-title-number').hide();
    $('.no_found').remove();
    var any = false;
    $.each($('.nsw-title-number'),function(index, val){
      var title = $(val).attr("data-store_title").toLowerCase();
     if(title.indexOf(search.toLowerCase().trim()) != -1){
       $(val).show();
       any = true;
     } 
    });
    if(any == false){
      $('.nsw-stores-scroll-inner').append("<p class='no_found'>No found.</p>");
    }
  });
  $('body').on('blur','.contact_us_wrapper .store_find',function(e){
    $('.no_found').remove();
    $('.ui-autocomplete').removeClass("hide_autosearch");
    $('.nsw-title-number').show();
  });

  /* maddenqood page*/
   $(window).scroll(function () { 
     if($('.maddenwood_header_section').length > 0){
      var scroll = $(window).scrollTop();
      if (scroll >= 200) {
          $(".maddenwood_header_right").addClass("maddenwood_header-sticky");
      } else {
          $(".maddenwood_header_right").removeClass("maddenwood_header-sticky");
      }
     }
 });    

    $('.paloma-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        dots: true,
        adaptiveHeight: true
    });

    
  if($(window).width() <= 991){
    var video_class = 'video.mobile_imgonly';
  } else{
    var video_class = 'video.desktop_imgonly';
  }
    //play button
    $("body").on('click','.main-btn.maddenwood_play_btn',function (e) {
      e.preventDefault();
        $(this).closest('.maddenwood_hero_section').find(".main-popup").toggleClass("active");
        $('body,html').toggleClass('scrollno');
        var get_video = $(this).closest('.maddenwood_hero_section').find(video_class)[0];
        if (get_video.paused){
          get_video.muted = false;
          get_video.play();
        }              
    });
    $("body").on("click",'.maddednwooed_popup .close-menu',function (e) {
      e.preventDefault();
        $(".main-popup").removeClass("active");
        $('body,html').removeClass('scrollno');
        var get_video = $(this).closest('.maddenwood_hero_section').find(video_class)[0];            
        get_video.muted = true;
        get_video.pause();                
    });
  /*maddenwood end */

  $('.faq-wrapper-list .accordian-item .accordian-title').click(function () {
    $('.faq-wrapper-list .accordian-item .accordian-title').removeClass('active');
    $('.faq-wrapper-list .accordian-item .accordian-content').slideUp();
    if (!$(this).next().is(':visible')) {
        $(this).next().slideDown();
        $(this).addClass('active');
    }
});
  
 $('.return_btn').on('click', function(){
    var iframe = document.querySelector('[title*="Button to launch"]');
    var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    iframeDocument.querySelector('button').click();  
  }); 
  
});

$(document).mouseup(function(e){
  var container = $('.inner_viral');
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".viralsweep_popup").removeClass('open_viralpopup');
    $("body").removeClass('open_viralpopupbody');
    if($('#myVideo').length) {
      document.getElementById("myVideo").pause();
    }
  }
});

if(navigator.platform.toLowerCase().indexOf('mac') >= 0 || navigator.userAgent.toLowerCase().indexOf('mac') >= 0){
  $('body').addClass("mac");
}


